<div class="slds-modal__footer">
  <ng-content></ng-content> 
  </div>
